import { useMemo } from 'react'

import { useInfiniteQuery } from '@tanstack/react-query'

import {
    AnalyticsTagType,
    BrandListingItemViewModel,
    BrandListingItemViewModelKibaPaginationViewModel,
} from '@/types/api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query'

import { PAGE_SIZE_OF_BRANDS } from '../constants'

export const useGetMenuBrands = (searchQuery: string, enabled: boolean = true) => {
    const query = searchQuery.length !== 1 ? searchQuery : ''
    const {
        data: infinitBrands,
        fetchNextPage,
        isFetching,
    } = useInfiniteQuery<BrandListingItemViewModelKibaPaginationViewModel>({
        queryKey: QueryKeys.Layout.MenuBrands(query),
        queryFn: ({ pageParam = 1 }) => {
            return fetchRequest({
                serviceName: 'ntl',
                method: 'GET',
                endpoint: `/catalog/brands?analytics_tag=${AnalyticsTagType.BrandList}&page_size=${PAGE_SIZE_OF_BRANDS}&page_number=${pageParam}&query=${
                    query || ''
                }`,
            })
        },
        getNextPageParam: (lastPage) => {
            const { totalCount = 0, pageSize = PAGE_SIZE_OF_BRANDS } = lastPage || {}
            const currentPage = lastPage.pageNumber || 1
            const pageCount = Math.ceil(totalCount / pageSize)
            return currentPage >= pageCount ? undefined : currentPage + 1
        },
        initialPageParam: 1,
        enabled,
        staleTime: Infinity,
    })

    const filteredBrands = useMemo(
        () =>
            infinitBrands?.pages.reduce((acc: BrandListingItemViewModel[], cur) => {
                const newItems = cur.items || []
                return [...acc, ...newItems]
            }, []) || [],
        [infinitBrands]
    )

    const { totalCount, pageNumber: lastPageNumber = 1 } = infinitBrands?.pages.at(0) || {}
    const pageCount = totalCount ? Math.ceil(totalCount / PAGE_SIZE_OF_BRANDS) : 0

    return { pageCount, lastPageNumber, filteredBrands, fetchNextPage, isFetching }
}
